var _templateObject;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
import React from 'react';
import parse, { attributesToProps } from 'html-react-parser';
import { Link } from '@olxbr/ds-web';
import styled from 'styled-components';
var LinkWithCustomColor = styled(Link)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  :hover {\n    color: ", ";\n  }  \n"])), function (props) {
  return props.colorLink ? props.colorLink : '#7b5613';
}, function (props) {
  return props.colorLink ? props.colorLink : '#7b5613';
});
var options = {
  replace: function replace(_ref) {
    var attribs = _ref.attribs;
    if (!attribs) {
      return;
    }
    var props = attributesToProps(attribs);
    if (attribs.id === 'Link') {
      return /*#__PURE__*/React.createElement(LinkWithCustomColor, _extends({
        href: attribs.href
      }, props), attribs.text);
    }
  }
};
export var parseHTML = function parseHTML(html) {
  return parse(html, options);
};